import createAPI from './create-api';
const api = createAPI(process.env.MUJI_APP_API_HELP);
export function fetchGroupAll() {
    return api.getJson('group/all');
}
export function fetchProjectAll() {
    return api.getJson('project/all');
}
export function fetchProjectDoc(id) {
    return api.getJson(`project/${id}/doc`);
}
